module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/Playade-Gros-134e35556919337f25a3754877df6d1a.jpg";